import { Injectable,isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppComponent } from '../app.component';


const API_LIST_ENDPOINT = '/idea';
@Injectable({
  providedIn: 'root'
})
export class IdeaserviceService {
constructor(private http: HttpClient) { }
getIdeas(): Observable<any> {
    return this.http.get(AppComponent.baseUrl + API_LIST_ENDPOINT+ '/list', { responseType: 'text' });
    }
newIdea(idea : any): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_LIST_ENDPOINT+ '/newidea', idea ,{ responseType: 'text' });
    }
removeIdea(id: number): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_LIST_ENDPOINT + '/removeidea', { id }, { responseType: 'text' });
    }

}
